// External Libraries
import {
  afterNextRender,
  ChangeDetectionStrategy,
  Component,
  inject,
  viewChild
} from '@angular/core';
import { Router } from '@angular/router';

import { CaptureComponent } from '../../../components/capture/capture.component';

/**
 * Post-upload filing step for ad-hoc document uploads (`/webcapture/documentupload`).
 * The uploaded document IDs are handed over via router navigation state by
 * `WebCaptureUploadComponent`.
 */
@Component({
  selector: 'app-document-upload',
  templateUrl: './document-upload.component.html',
  imports: [CaptureComponent],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DocumentUploadComponent {
  private router = inject(Router);

  private captureComponent = viewChild(CaptureComponent);

  private docIds: string[] = [];

  constructor() {
    const state = this.router.getCurrentNavigation()?.extras.state ?? history.state;
    this.docIds = Array.isArray(state?.['docIds']) ? state['docIds'] : [];

    if (this.docIds.length === 0) {
      // Session state is lost on refresh or direct routing. This will need to be updated when we allow adhoc sessions to add documents to it.
      this.router.navigate(['/webcapture']);
      return;
    }

    afterNextRender(() => this.captureComponent()?.startAdHocFiling(this.docIds));
  }

  /**
   * Returns to the upload page once filing is finished or restarted.
   */
  onRestartFiling(): void {
    this.router.navigate(['/webcapture']);
  }

  /**
   * Check if component can deactivate.
   */
  canDeactivate(): boolean | Promise<boolean> {
    return this.captureComponent()?.canDeactivate() ?? true;
  }
}
